<script>
export const group = 'Full'
</script>

<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import AnimatedBackground from '../../AnimatedBackground.vue'
import ToFullTopLeft from './transitions/energetic_frequencies/ToFullTopLeft.vue'
import PositiveWaveLoop1 from '../../../assets/animations/energetic_frequencies/loops/positive_wave_loop_1.json'
import ArticleFull from './shared/ArticleFull.vue'

defineProps({
  item: Object,
})

const schemes = [
  { backgroundColor: colors.q.cr.red.primary, color: colors.q.cr.red.darker },
  { backgroundColor: colors.q.cr.gray.primary, color: colors.q.cr.gray.darker },
]

// This is a temporary solution to prevent the same color scheme from being used twice in a row.
// A more proper background color scheme selection (including logo color picking) should be implemented in the future.
const schemeIndex = ((window.lastUsedSchemeIndex ?? 1) + 1) % schemes.length
window.lastUsedSchemeIndex = schemeIndex

const scheme = schemes[schemeIndex]
</script>

<template>
  <ToFullTopLeft>
    <AnimatedBackground :lottie="PositiveWaveLoop1" :backgroundColor="scheme.backgroundColor" :color="scheme.color">
      <ArticleFull :title="item.properties.title" :imageUrl="item.properties.image">
        {{ item.properties.body }}
      </ArticleFull>
    </AnimatedBackground>
  </ToFullTopLeft>
</template>
